module.exports = __webpack_public_path__ + "static/media/location2.ba0d8ecb.svg";